import routes from "./router/routes"
import type { Router } from "vue-router"
import type eventBusType from "@/events/event-bus"

export function authModule({ router }: { router: Router; eventBus: typeof eventBusType }) {
  for (const route of routes) router.addRoute(route)
}
